import { matchPath } from "react-router-dom";
import { systemCode, urls } from "../../..";
import { arePathnamesEqual, removeMultipleSlashes } from "../../../data/sport-utils";
import { appConfig } from "../../../appConfig";
import { getLegacyRoutes } from "./legacy-routes";

export function load_xs_routes(systemCode) {
    const legacyRoutes = getLegacyRoutes();
    if (!legacyRoutes) {
        return;
    }

    function removeFirstSlash(path) {
        if(path && path.startsWith('/') && path !== '/' ) {
            return path.substring(1);
        }
        return path;
    }

    function removeLastSlash(path) {
        if(path && path.endsWith('/')  && path !== '/' ) {
            return path.substring(0,path.length-1);
        }
        return path;
    }

    window.xs_routes[systemCode] = {
        "basename": appConfig['BASENAME'],
        "base":  window.xs_routes?.['DEFAULT']?.["base"] === appConfig.BASENAME ? appConfig.BASENAME : appConfig.BASENAME === '/' ? "" : appConfig.BASENAME,
        "base_env": window.xs_routes?.['DEFAULT']?.['base'],
        "betslip": removeFirstSlash(appConfig['ROUTES']['prematch']['betslip']),
        "mybets":removeFirstSlash(appConfig['ROUTES']['prematch']['mybets']),
        "favorite-odds":removeFirstSlash(appConfig['ROUTES']['prematch']['favorite-odds']),
        "today-odds":removeFirstSlash(appConfig['ROUTES']['prematch']['today-odds']),
        "calendar":removeFirstSlash(appConfig['ROUTES']['live']['calendar']),
        "checkbet":removeFirstSlash(appConfig['ROUTES']['prematch']['checkbet']),
        "checksystembets":removeFirstSlash(appConfig['ROUTES']['prematch']['checksystembets']),
        "live": {
            "base": removeLastSlash(removeFirstSlash(appConfig?.['ROUTES']?.['live']?.['live'])),
            "event": "evento",
            "tournament": "torneo",
        },
        "notFound": "404",
        "prematch": {
            "allMatches": "tutte",
            "base": removeLastSlash(removeFirstSlash(appConfig?.['ROUTES']?.['prematch']?.['prematch'])),
            "date": "g",
            "event": "evento",
            "betbuilder_event" : "betbuilder-event",
            "home": "",
            "today": "oggi",
            "tournament": "torneo",
            "category":"categoria",
            "sportsMenu": "menu"
        },
        "sport-home": {
            "sport-home":removeLastSlash(removeFirstSlash(appConfig?.['ROUTES']?.['sport-home']?.['sport-home']))
        },
        "search": "cerca"
    }
}

function isEnvironmentBasename(pathname) {
    const isEnvBasename = (window.xs_routes?.[systemCode]?.["base_env"] === appConfig.BASENAME) || (pathname?.startsWith( window.xs_routes?.['DEFAULT']?.['basename']));
    return isEnvBasename;
}

export function getPathnameRouteInfo(pathname) {
    const isEnvBasename = isEnvironmentBasename(pathname);
    let cleanedUpPathname;
    
    if(isEnvBasename) {
        cleanedUpPathname = pathname?.replace(appConfig.BASENAME,'');
    }else{
        cleanedUpPathname = pathname;
    }
    const routeFromPathname = appConfig.ROUTES.routeFromPath(cleanedUpPathname) || appConfig.ROUTES.routeFromPath(cleanedUpPathname.replace(appConfig.BASENAME,''));

    return [routeFromPathname,cleanedUpPathname,isEnvBasename];
}

export function sectionFromXroutes(pathname) {
    const pathPrematch = matchPath({path: removeMultipleSlashes(`${urls.basename}/${urls.prematch.base}`),end: false,caseSensitive: false},pathname);
    const pathLive = matchPath({path: removeMultipleSlashes(`${urls.basename}/${urls.live.base}`),end: false,caseSensitive: false},pathname);
    const pathBetslip = matchPath({path: removeMultipleSlashes(`${urls.basename}/${urls.betslip}`),end: false,caseSensitive: false},pathname);
    const pathMybets = matchPath({path: removeMultipleSlashes(`${urls.basename}/${urls.mybets}`),end: false,caseSensitive: false},pathname);

    const matchingPath = pathPrematch?.pathname || pathLive?.pathname || pathBetslip?.pathname || pathMybets?.pathname;

    return matchingPath?.replace(`${urls.basename}/`,'');
}

export function xSectionFromPath(pathname,sections) {
    const isEnvBasename =  isEnvironmentBasename(pathname);
    let path;
    if(isEnvBasename) {
        path = pathname.replace(appConfig.BASENAME,'');
    }else{
        path = pathname;
    }
    return appConfig.ROUTES.sectionFromPath(path,sections);
}

export function getPrematchBasePath() {
    return removeMultipleSlashes(`${urls.base}/${urls.prematch.base}`);
}

export function isPrematchBasePath(path) {
    return arePathnamesEqual(path,`${urls.base}/${urls.prematch.base}`)
}
